import SearchBanner from './SearchBanner.vue';

export default SearchBanner;
